import { render } from "./evaAgeEchart.vue?vue&type=template&id=b3b3949e&scoped=true"
import script from "./evaAgeEchart.vue?vue&type=script&lang=js"
export * from "./evaAgeEchart.vue?vue&type=script&lang=js"

import "./evaAgeEchart.vue?vue&type=style&index=0&id=b3b3949e&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b3949e"]])

export default __exports__